import { call, put, takeEvery } from "redux-saga/effects";
import { toast } from "react-toastify";
import {
  CHANGE_PREOFFER_STATUS,
  FETCH_BGC_COUNTS,
  FETCH_PREOFFER_CANDIDATES,
  FETCH_PREOFFER_COUNTS,
  FETCH_SLA_COUNTS,
  OFFER_STATUS,
  OFFER_STATUS_WITH_ATTACHMENT,
} from "./actionTypes";
import {
  changeStatusFailure,
  changeStatusSuccess,
  fetchBGCCountsFailure,
  fetchBGCCountsSuccess,
  fetchPreOfferCandidatesFailure,
  fetchPreOfferCandidatesSuccess,
  fetchPreOfferCountsFailure,
  fetchPreOfferCountsSuccess,
  fetchSLACountsFailure,
  fetchSLACountsSuccess,
  offerStatusFailure,
  offerStatusSuccess,
} from "./action";
import {
  changePreOfferStatus,
  getBGCCounts,
  getPreOfferCandidates,
  getPreOfferCounts,
  getSLACounts,
  offerStatusService,
  offerStatusServiceWithAttachments,
} from "../../../../candidate/src/helpers/backend_helper";
import { JOB_STAGE_STATUS } from "../../components/JobListing/JobListingConstants";

function* worksFetchCandidates(action) {
  try {
    const response = yield call(getPreOfferCandidates, action.payload);
    yield put(fetchPreOfferCandidatesSuccess(response.data));
  } catch (error) {
    yield put(fetchPreOfferCandidatesFailure(error));
  }
}

function* worksFetchCounts(action) {
  try {
    const response = yield call(getPreOfferCounts, action.payload);
    yield put(fetchPreOfferCountsSuccess(response.data));
  } catch (error) {
    yield put(fetchPreOfferCountsFailure(error));
  }
}

function* worksFetchSLACounts(action) {
  try {
    const response = yield call(getSLACounts, action.payload);
    yield put(fetchSLACountsSuccess(response.data));
  } catch (error) {
    yield put(fetchSLACountsFailure(error));
  }
}

function* worksFetchBGCCounts(action) {
  try {
    const response = yield call(getBGCCounts, action.payload);
    yield put(fetchBGCCountsSuccess(response.data));
  } catch (error) {
    yield put(fetchBGCCountsFailure(error));
  }
}

function* worksChangeStatus(action) {
  try {
    const response = yield call(changePreOfferStatus, action.payload);
    yield put(changeStatusSuccess(response.data));
    toast.success("Pre-Offer has been verified successfully.");
  } catch (error) {
    yield put(changeStatusFailure(error));
  }
}

function* worksOfferStatus(action) {
  try {
    const response = yield call(offerStatusService, action.payload);
    yield put(offerStatusSuccess(response.data));
    const offerType = action.payload.offerType;
    const status = action.payload.status;
    if (offerType === "create_offer" && status === JOB_STAGE_STATUS.DRAFT) {
      toast.success("Offer has been saved to draft.");
    } else if (
      offerType === "create_offer" &&
      status === JOB_STAGE_STATUS.SUBMITTED
    ) {
      toast.success("Offer created successfully.");
    } else if (offerType === "offer_review") {
      if (status === JOB_STAGE_STATUS.REVIEWED) {
        toast.success("Offer letter reviewed.");
      } else if (status === JOB_STAGE_STATUS.CORRECTION_NEEDED) {
        toast.success("Offer send back for correction.");
      }
    } else if (
      offerType === "offer_approval" &&
      status === JOB_STAGE_STATUS.APPROVED
    ) {
      toast.success("Offer letter approved.");
    } else if (
      offerType === "offer_approval" &&
      status === JOB_STAGE_STATUS.REJECTED
    ) {
      toast.success("Offer has been rejected.");
    } else if (offerType === "offer_acceptance") {
      toast.success("Offer status updated successfully.");
    } else {
      toast.success("Operation submitted successfully.");
    }
  } catch (error) {
    yield put(offerStatusFailure(error));
  }
}

function* worksOfferStatusWithAttachments(action) {
  const { formData, config } = action.payload;
  try {
    // Tag a job
    const response = yield call(
      offerStatusServiceWithAttachments,
      formData,
      config
    );
    yield put(offerStatusSuccess(response.data));
    toast.success("Offer letter sent successfully.");
  } catch (error) {
    yield put(offerStatusFailure(error));
  }
}

export default function* watchFetchCandidateSaga() {
  yield takeEvery(FETCH_PREOFFER_CANDIDATES, worksFetchCandidates);
  yield takeEvery(FETCH_PREOFFER_COUNTS, worksFetchCounts);
  yield takeEvery(FETCH_SLA_COUNTS, worksFetchSLACounts);
  yield takeEvery(FETCH_BGC_COUNTS, worksFetchBGCCounts);
  yield takeEvery(CHANGE_PREOFFER_STATUS, worksChangeStatus);
  yield takeEvery(OFFER_STATUS, worksOfferStatus);
  yield takeEvery(
    OFFER_STATUS_WITH_ATTACHMENT,
    worksOfferStatusWithAttachments
  );
}
